import { useParams } from 'react-router-dom';
import { ItemDetailView } from '../components/item-detail/ItemDetailView';

export function ItemDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) {
    return (
      <>
        <div className="flex-1 flex items-center justify-center text-sm text-slate-400">
          Geen item-ID opgegeven
        </div>
      </>
    );
  }
  return (
    <>
      <ItemDetailView itemId={id} />
    </>
  );
}
